/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React, { type ComponentType } from 'react';
/**
 * Retrieves a readable identifier for a given component, ensuring meaningful names in debugging and logging.
 */
export const getDisplayName = <T,>(WrappedComponent: ComponentType<T>): string => {
	if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '')
		return WrappedComponent.displayName;
	if (WrappedComponent.name != null && WrappedComponent.name !== '') {
		return WrappedComponent.name;
	}
	return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */
const withInjectedProps = <TProps, TInjected extends Partial<TProps>, TDefault>(
	WrappedComponent: ComponentType<TProps> & {
		defaultProps?: TDefault;
	},
	injectedProps: TInjected,
): React.FunctionComponent<
	Omit<Omit<TProps, keyof TDefault> & Partial<TDefault>, keyof TInjected>
> => {
	type PropsWithDefault = Omit<TProps, keyof TDefault> & Partial<TDefault>;
	type PropsWithoutInjected = Omit<PropsWithDefault, keyof TInjected>;
	const WithInjectedProps: ComponentType<PropsWithoutInjected> = (props) => (
		// oxlint-disable-next-line typescript/consistent-type-assertions
		<WrappedComponent {...injectedProps} {...(props as TProps)} />
	);
	WithInjectedProps.displayName = `withInjectedProps(${getDisplayName(WrappedComponent)})`;
	return WithInjectedProps;
};
export default withInjectedProps;
